import React from "react";
import PropTypes from "prop-types";
import { Badge } from "@opendate-app/setlist";

const FORMAT_COLORS = { in_person: "blue", blended: "purple", online: "indigo" };
export const FORMAT_LABELS = { in_person: "In-person", blended: "Blended", online: "Online" };

export default function ClassFormatBadge({ format, size = "sm" }) {
  if (!format) return null;
  return <Badge color={FORMAT_COLORS[format] || "gray"} size={size} dot>{FORMAT_LABELS[format] || format}</Badge>;
}

ClassFormatBadge.propTypes = {
  format: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
};
